import { emptyArr, emptyObj } from '@beef/utils';
import { getSelectedTvPackages } from "./tvChannels";
import { getExcludedWifiRouters, getSelectedWifiRouters } from "./wifiRouters";
import { getExcludedTvConsoles, getSelectedAdditionalTvConsoles, getSelectedTvConsolesForChange } from "./tvConsoles";

// Принимает на вход модель страницы и работает с ней
export var getPopupDataFromPageData = function getPopupDataFromPageData(originData, type) {
  var _originData$popups;
  var popup = originData === null || originData === void 0 || (_originData$popups = originData.popups) === null || _originData$popups === void 0 ? void 0 : _originData$popups.find(function (p) {
    return p.type === type;
  });
  if (popup) return popup.data;
  return null;
};
var selectExternalTariffPage = function selectExternalTariffPage(_ref) {
  var external = _ref.external;
  return (external === null || external === void 0 ? void 0 : external.fttbTariffPage) || emptyObj;
};
export var getFTTBTariffPageData = function getFTTBTariffPageData(state) {
  return selectExternalTariffPage(state).originData || emptyObj;
};
export var getFTTBTariffPagePopupByType = function getFTTBTariffPagePopupByType(state, type) {
  return getPopupDataFromPageData(getFTTBTariffPageData(state), type) || emptyObj;
};
export var getSelectedAdditionalServices = function getSelectedAdditionalServices(state) {
  return selectExternalTariffPage(state).selectedAdditionalServices || emptyArr;
};
export var getSelectedAntiviruses = function getSelectedAntiviruses(state) {
  return selectExternalTariffPage(state).selectedAntiviruses || emptyArr;
};

// TODO: Memoize object
export var getAllSelectedServices = function getAllSelectedServices(state) {
  return {
    tvPackages: getSelectedTvPackages(state),
    additionalServices: getSelectedAdditionalServices(state),
    antiviruses: getSelectedAntiviruses(state),
    wifiRouters: getSelectedWifiRouters(state),
    tvConsolesForChange: getSelectedTvConsolesForChange(state),
    additionalTvConsoles: getSelectedAdditionalTvConsoles(state)
  };
};
export var getAllExcludedServices = function getAllExcludedServices(state) {
  return {
    excludedRouters: getExcludedWifiRouters(state),
    excludedTvConsoles: getExcludedTvConsoles(state)
  };
};